import styled from 'styled-components'

export const PageHeader = styled.div`
  margin-bottom: 22px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;

  h1 {
    margin: 0;
    color: #2f3640;
    font-size: 24px;
  }

  p {
    max-width: 680px;
    margin: 7px 0 0;
    color: #808894;
    font-size: 11px;
    line-height: 1.55;
  }

  @media (max-width: 680px) {
    flex-direction: column;
    align-items: stretch;
  }
`

export const PrimaryButton = styled.button`
  min-height: 40px;
  padding: 0 14px;
  border: 0;
  border-radius: 9px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  background: #e00000;
  color: #fff;
  font-size: 10px;
  font-weight: 800;
  cursor: pointer;

  &:hover {
    background: #c90000;
  }
`

export const TableCard = styled.div`
  border: 1px solid #e5e8ed;
  border-radius: 14px;
  overflow: hidden;
  background: #fff;
`

export const TableScroll = styled.div`
  width: 100%;
  overflow-x: auto;
`

export const AdTable = styled.table`
  width: 100%;
  min-width: 900px;
  border-collapse: collapse;

  th {
    padding: 11px 12px;
    border-bottom: 1px solid #e8ebef;
    background: #f8fafb;
    color: #8b929d;
    font-size: 8px;
    font-weight: 800;
    text-align: left;
    text-transform: uppercase;
    letter-spacing: 0.04em;
  }

  td {
    padding: 12px;
    border-bottom: 1px solid #eef1f4;
    color: #5f6874;
    font-size: 9px;
    vertical-align: middle;
  }

  tr:last-child td {
    border-bottom: 0;
  }
`

export const AdIdentity = styled.div`
  min-width: 220px;
  display: flex;
  align-items: center;
  gap: 10px;

  img {
    width: 52px;
    height: 34px;
    border-radius: 7px;
    object-fit: cover;
    background: #f0f2f4;
  }

  strong,
  span {
    display: block;
  }

  strong {
    max-width: 220px;
    overflow: hidden;
    color: #343b46;
    font-size: 10px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  span {
    margin-top: 3px;
    color: #949ba5;
    font-size: 8px;
  }
`

export const FormatBadge = styled.span<{ $format: 'horizontal' | 'card' }>`
  padding: 5px 8px;
  border-radius: 999px;
  display: inline-flex;
  background: ${({ $format }) =>
    $format === 'horizontal' ? '#eef5ff' : '#f5f1ff'};
  color: ${({ $format }) => ($format === 'horizontal' ? '#2868b9' : '#6f46b4')};
  font-size: 8px;
  font-weight: 800;
`

export const StatusBadge = styled.span<{ $active: boolean }>`
  padding: 5px 8px;
  border-radius: 999px;
  display: inline-flex;
  background: ${({ $active }) => ($active ? '#e9f9ef' : '#f1f3f5')};
  color: ${({ $active }) => ($active ? '#26844d' : '#7d858f')};
  font-size: 8px;
  font-weight: 800;
`

export const LocalityCell = styled.div`
  min-width: 150px;

  strong,
  span {
    display: block;
  }

  strong {
    color: #414955;
    font-size: 10px;
  }

  span {
    max-width: 210px;
    margin-top: 3px;
    overflow: hidden;
    color: #9299a3;
    font-size: 8px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`

export const Actions = styled.div`
  display: flex;
  gap: 5px;

  button {
    padding: 6px 8px;
    border: 1px solid #dde2e7;
    border-radius: 7px;
    background: #fff;
    color: #5f6874;
    font-size: 8px;
    font-weight: 700;
    cursor: pointer;
  }

  button:hover {
    border-color: #c9ced5;
    color: #2f3640;
  }

  button.danger {
    color: #c62b2b;
  }
`

export const EmptyState = styled.div`
  padding: 34px 20px;
  color: #949ba4;
  font-size: 10px;
  text-align: center;
`

export const FormGrid = styled.div`
  padding: 4px 0 8px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;

  @media (max-width: 680px) {
    grid-template-columns: 1fr;
  }
`

export const Field = styled.div<{ $wide?: boolean }>`
  min-width: 0;
  grid-column: ${({ $wide }) => ($wide ? '1 / -1' : 'auto')};

  label {
    display: block;
    margin-bottom: 6px;
    color: #555e6b;
    font-size: 9px;
    font-weight: 800;
  }

  input,
  select {
    width: 100%;
    height: 40px;
    padding: 0 10px;
    border: 1px solid #dfe3e8;
    border-radius: 9px;
    background: #fff;
    color: #3f4752;
    font-family: inherit;
    font-size: 10px;
    outline: 0;
    box-sizing: border-box;
  }

  input:focus,
  select:focus {
    border-color: rgba(224, 0, 0, 0.35);
    box-shadow: 0 0 0 3px rgba(224, 0, 0, 0.05);
  }

  @media (max-width: 680px) {
    grid-column: auto;
  }
`

export const ImageInputRow = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 8px;
  align-items: center;

  > input {
    min-width: 0;
  }

  > label {
    height: 40px;
    margin: 0;
    padding: 0 13px;
    border: 1px solid #e00000;
    border-radius: 9px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 7px;
    background: #ffffff;
    color: #d50000;
    font-size: 9px;
    font-weight: 800;
    white-space: nowrap;
    cursor: pointer;
    box-sizing: border-box;
  }

  > label:hover {
    background: #fff5f5;
  }

  @media (max-width: 560px) {
    grid-template-columns: 1fr;

    > label {
      width: 100%;
    }
  }
`

export const FieldHint = styled.small`
  display: block;
  margin-top: 6px;
  color: #9299a3;
  font-size: 8px;
  line-height: 1.45;
`

export const FormatSelector = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;

  @media (max-width: 560px) {
    grid-template-columns: 1fr;
  }
`

export const FormatOption = styled.button<{ $active: boolean }>`
  min-height: 96px;
  padding: 13px;
  border: 1px solid
    ${({ $active }) => ($active ? 'rgba(224, 0, 0, 0.45)' : '#e2e6ea')};
  border-radius: 11px;
  background: ${({ $active }) => ($active ? '#fff7f7' : '#fff')};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 5px;
  text-align: left;
  cursor: pointer;

  > span {
    display: block;
    margin-bottom: 3px;
    border-radius: 4px;
    background: ${({ $active }) => ($active ? '#e00000' : '#cfd4da')};
  }

  > span.wide {
    width: 62px;
    height: 14px;
  }

  > span.card {
    width: 34px;
    height: 24px;
  }

  strong {
    color: #3b434e;
    font-size: 10px;
  }

  small {
    color: #8f97a1;
    font-size: 8px;
    line-height: 1.4;
  }
`

export const LocalityPicker = styled.div`
  border: 1px solid #e0e4e8;
  border-radius: 11px;
  overflow: hidden;

  > input {
    border: 0;
    border-bottom: 1px solid #edf0f2;
    border-radius: 0;
  }
`

export const SelectedLocations = styled.div`
  min-height: 42px;
  padding: 8px;
  border-bottom: 1px solid #edf0f2;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
  background: #fafbfc;

  button {
    padding: 5px 8px;
    border: 0;
    border-radius: 999px;
    background: #ffecec;
    color: #b52020;
    font-size: 8px;
    font-weight: 700;
    cursor: pointer;
  }

  > span {
    color: #9aa1aa;
    font-size: 8px;
  }
`

export const LocalityResults = styled.div`
  max-height: 220px;
  overflow-y: auto;

  > span {
    display: block;
    padding: 14px;
    color: #9098a2;
    font-size: 9px;
  }

  button {
    width: 100%;
    padding: 10px 12px;
    border: 0;
    border-bottom: 1px solid #f0f2f4;
    display: grid;
    grid-template-columns: 18px minmax(0, 1fr) 20px;
    align-items: center;
    gap: 8px;
    background: #fff;
    color: #6f7884;
    text-align: left;
    cursor: pointer;
  }

  button:last-child {
    border-bottom: 0;
  }

  button:hover,
  button.selected {
    background: #fff8f8;
  }

  svg {
    color: #d90000;
  }

  strong,
  span {
    display: block;
  }

  strong {
    color: #3e4651;
    font-size: 9px;
  }

  span {
    margin-top: 2px;
    color: #9ba2ab;
    font-size: 7px;
  }

  b {
    color: #d90000;
    font-size: 13px;
    text-align: center;
  }
`

export const Preview = styled.div<{ $format: 'horizontal' | 'card' }>`
  width: ${({ $format }) =>
    $format === 'horizontal' ? '100%' : 'min(420px, 100%)'};
  aspect-ratio: ${({ $format }) =>
    $format === 'horizontal' ? '4 / 1' : '16 / 9'};
  border: 1px solid #e1e5e9;
  border-radius: 12px;
  overflow: hidden;
  background: #f4f6f7;

  picture,
  img {
    width: 100%;
    height: 100%;
    display: block;
  }

  img {
    object-fit: cover;
  }
`

export const ConfirmModal = styled.div`
  width: min(430px, 100%);
  padding: 24px;
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 28px 80px rgba(0, 0, 0, 0.24);

  @media (max-width: 580px) {
    width: 100%;
    padding: 18px;
    border-radius: 20px 20px 12px 12px;
  }
`

export const ConfirmIcon = styled.div`
  width: 44px;
  height: 44px;
  margin-bottom: 14px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff0f0;
  color: #d90000;

  svg {
    font-size: 17px;
  }
`

export const ConfirmContent = styled.div`
  h2 {
    margin: 0;
    color: #252c37;
    font-size: 20px;
    line-height: 1.2;
  }

  p {
    margin: 10px 0 0;
    color: #69717c;
    font-size: 11px;
    line-height: 1.6;
  }

  @media (max-width: 580px) {
    h2 {
      font-size: 18px;
    }

    p {
      font-size: 10px;
    }
  }
`
